import { useTheme } from 'foundations-theming/utils';
import PropTypes from 'prop-types';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { DeleteIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
const CallRecordingDeleteButton = ({
  onDeleteRecording,
  disableDelete = false
}) => {
  const trellisTheme = useTheme();
  return /*#__PURE__*/_jsx(IconButton, {
    color: trellisTheme.color['do-not-use-calypso'],
    "data-selenium-test": "call-recording-delete-button",
    "data-test-id": "call-recording-delete-button",
    onClick: onDeleteRecording,
    disabled: disableDelete,
    size: "md",
    use: "link",
    marginInlineStart: "200",
    children: /*#__PURE__*/_jsx(DeleteIcon, {})
  });
};
CallRecordingDeleteButton.propTypes = {
  onDeleteRecording: PropTypes.func.isRequired
};
export default CallRecordingDeleteButton;